<!-- manage postcode map html component -->
<p-confirmDialog
  header="Confirmation"
  icon="fa-icon-circle"
  [style]="{ width: '425px' }"
  acceptLabel="Save"
  rejectLabel="Cancel"
></p-confirmDialog>

<div class="ui-g ui-fluid">
  <div class="ui-g-12 ui-lg-12">
    <div class="card card-w-title">
      <!-- Pagetitle -->
      <h1 *ngIf="!isBusy; else loading">Job Postcode Areas</h1>
      <span *ngIf="orgnodes.length <= 0"
        >There was no organisation structure data found. Log in with a supplier user if you are
        not.</span
      >
      <div class="ui-g" *ngIf="orgnodes.length > 0">
        <!-- div -->
        <div class="ui-g-3 ui-sm-12">
          <!-- div -->
          <!-- Tree control -->
          <p-tree
            *ngIf="selectedNode != undefined && orgnodes.length > 0"
            [value]="orgnodes"
            selectionMode="single"
            [(selection)]="selectedNode"
            (onNodeSelect)="nodeSelect($event)"
            autoWidth="false"
            [style]="{ width: '100%' }"
          ></p-tree>

          <div class="ui-grid-row">
            <div class="ui-g-12"></div>
            <button
              pButton
              (click)="save()"
              type="submit"
              label="Save"
              class="btn-to-right"
              [disabled]="currentnodetype == 'Region'"
            ></button>
            <button
              pButton
              (click)="close()"
              type="button"
              label="Close"
              class="btn-to-right"
            ></button>
          </div>
        </div>
        <!-- div -->
        <div class="ui-g-9 ui-sm-12" *ngIf="currentnodetype != 'Region'">
          <p-tabView>
            <p-tabPanel id="tabUKPostcodes" header="UK" #tabUKPostcodes>
              <postcode-map-uk
                [ukDatas]="ukcodes"
                (UKCodeChange)="onUKCodeChange($event)"
              ></postcode-map-uk>
            </p-tabPanel>
            <p-tabPanel id="tabLondonPostcodes" header="London" #tabLondonPostcodes>
              <postcode-map-london
                [datas]="londoncodes"
                (londonCodeChange)="onLondonCodeChange($event)"
              ></postcode-map-london>
            </p-tabPanel>
          </p-tabView>
        </div>
      </div>
      <!-- loading template -->
      <ng-template #loading
        ><h1>Please wait... &nbsp;<i class="fa fa-spinner fa-spin"></i></h1
      ></ng-template>
    </div>
  </div>
</div>
